import { Text } from "@minuthq/meatball-ui-react"

import { ParadiseDetailsSection } from "src/components/Paradise/ParadiseDetailsLayout"
import { ParadiseTable } from "src/components/Paradise/ParadiseTable"
import { TParadiseUser } from "src/data/paradise/paradiseUsers/types/paradiseUserQueryTypes"
import {
  TableColumn,
  useTableColumns,
} from "src/ui/GridTable/useTableColumns/useTableColumns"
import { formatDate } from "src/utils/l10n"

export function ParadiseUserAppInstallations({
  appInstallations,
}: {
  appInstallations: TParadiseUser["app_installations"]
}) {
  const headers: TableColumn<TParadiseUser["app_installations"][number]>[] = [
    {
      value: "platform",
      label: "Platform",
      columnWidth: "min-content",
      renderCell: (app) => {
        let platform = "Unknown"
        if (app.client_type === "ios") platform = "iOS"
        if (app.client_type === "android") platform = "Android"
        if (app.client_type === "web") platform = "Web"
        return <Text variant="bodyS">{platform}</Text>
      },
    },
    {
      value: "app_version",
      label: "Version",
      columnWidth: "auto",
      renderCell: (app) => (
        <Text variant="bodyS">
          {app.client_type === "web" ? " N/A" : app.app_version}
        </Text>
      ),
    },
    {
      value: "updated_at",
      label: "Updated at",
      columnWidth: "auto",
      renderCell: (app) => (
        <Text variant="bodyS">
          {app.updated_at !== undefined
            ? formatDate({
                date: app.updated_at,
              })
            : "Unknown"}
        </Text>
      ),
    },
  ]

  const { headerElements, rows, templateColumns } = useTableColumns({
    columns: headers,
    data: appInstallations,
  })

  return (
    <div>
      <ParadiseDetailsSection title="App installations" />
      <ParadiseTable
        header={headerElements}
        rows={rows}
        templateColumns={templateColumns}
      />
    </div>
  )
}
